import React from "react";
import { IconButton } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import { messengerText as text } from "../../translate/messenger";

export default function TicketHeader({ loading, children }) {
  const history = useHistory();
  return <header className="tw-flex tw-min-h-[72px] tw-shrink-0 tw-items-center tw-gap-1 tw-border-0 tw-border-b tw-border-solid tw-border-slate-100 tw-bg-white tw-px-2 sm:tw-px-5 dark:tw-border-slate-700 dark:tw-bg-[#172b22]">
    <IconButton aria-label={text("back")} onClick={() => history.push("/tickets")} className="tw-text-messenger-green md:tw-hidden"><ArrowBack /></IconButton>
    {loading ? <TicketHeaderSkeleton /> : children}
  </header>;
}
